
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonBlockTitle from '@/components/common/CommonBlockTitle.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import CommonTab from '@/components/common/CommonTab.vue';
import GuideCard from './GuideCard.vue';
import ReportCard from './ReportCard.vue';
import { tabProject } from '@/types/tabList';
import { homeTitle, homeReportTabList, STAT, AJAX_STATUS } from '@/config/config';
import { getClientHeight, formateHkStockcode, getDomTop } from '@/utils/tools';
import { getHomeReportList, getReadNum } from '@/apis/index';

@Component({
  components: {
    CommonBlockLine,
    CommonBlockTitle,
    CommonRankNumber,
    CommonLoading,
    CommonTab,
    GuideCard,
    ReportCard,
  },
})
export default class ReportBlock extends Vue {
  @Prop() private scrollTop!: number;
  @Prop() private yhybBannerImg!: string;
  @Prop() private activeTabIndex!: number;
  @Prop() private slide!: number;
  // tab切换信息
  tabList: tabProject[] = homeReportTabList;
  // 缓存信息 每日一报
  dailyList = [];
  // 缓存信息 金股
  goldList = [];
  // 缓存信息 首次覆盖
  coverList = [];
  // 标题信息
  homeTitle = homeTitle;
  // 激活的索引
  activeIndex = 0;
  // 接口请求状态
  ajaxStatus = AJAX_STATUS.loading;
  stat = STAT.homeRecommend;
  // tab切换相关的配置信息
  configInfo = [
    {
      // 是否展示图表
      chart: false,
      // 是否为机构
      isOrg: true,
      // 是否展示关注
      follow: true,
      // 设置固定的名称
      plusName: '',
    },
    {
      chart: true,
      isOrg: true,
      follow: true,
      plusName: '',
    },
    {
      chart: false,
      isOrg: true,
      follow: true,
      plusName: '投研BBC',
    },
  ];
  clientHeight = 0;
  totalHeight = 0;
  viewHeight = 0;
  isAjaxing = false;
  // 消除页面加载时高度变动的滚动
  listHeight = '100vh';
  isInitCardJump = false;
  // 数组key信息
  keyArr = ['goldList', 'coverList', 'dailyList'];
  @Watch('scrollTop')
  onScrollTopChanged(newValue) {
    // 监听滚动按需加载
    if (newValue + this.viewHeight >= this.totalHeight && this.activeTabIndex === this.slide) {
      this.getData(true);
    }
  }
  get list() {
    // 用来展示的列表
    return this[this.keyArr[this.activeIndex]];
  }
  get config() {
    return this.configInfo[this.activeIndex];
  }
  get fromCardPid() {
    // 链接中携带的pid
    const pid = window.getParam('pid');
    if (window.getParam('jumpTab') === 'cover') {
      // 全量约束条件 避免影响 如果有pid则返回没有的话需要设置一个字符串状态 进行标记需要滚动
      return pid || '0';
    } else {
      // 地址信息不匹配
      return '';
    }
  }
  followOrg(id: string, status: boolean) {
    // 关注机构
    Vue.set(this.$followOrgList, id, status ? 2 : 1);
  }
  handleTabClick(index: number) {
    // tab点击事件处理 索引缓存
    this.activeIndex = index;
    // 处理tab数据
    this.tabList = this.handleTabInfo(index, this.tabList);
    const arr = this[this.keyArr[this.activeIndex]];
    const len = arr.length;
    if (!len) {
      this.getData();
      const dom = this.$refs.reportBlock as HTMLElement;
      // 设置列表的min-height避免滚动
      this.listHeight = `${window.innerHeight - dom.getBoundingClientRect().top}px`;
    }
  }
  handleTabInfo(index: number, arr: tabProject[]) {
    // 这里是格式化tab数据这里和tab组件一起优化一下有点繁琐
    return arr.map((item: tabProject, inn: number) => {
      item.isActive = false;
      if (inn === index) {
        item.isActive = true;
      }
      return item;
    });
  }
  getData(flag: boolean = false) {
    const { nomore, loading, nodata } = AJAX_STATUS;
    if (this.isAjaxing || (flag && this.ajaxStatus === nomore)) {
      // 接口请求中或者是滚动加载并且已经加载完
      return;
    }
    // 获取对应tab的数据
    const typeArr = ['gold', 'cover', 'week'];
    // 获取当前展示的数据
    const arr = this[this.keyArr[this.activeIndex]];
    const len = arr.length;
    this.isAjaxing = true;
    this.ajaxStatus = loading;
    // 获取研报信息
    getHomeReportList({
      report_type: typeArr[this.activeIndex],
      seq: len ? arr[len - 1].seq : '',
    })
      .then(res => {
        this.isAjaxing = false;
        if (res.statusCode === 0) {
          this.handleData(res);
        } else {
          this.ajaxStatus = nodata;
        }
      })
      .catch(() => {
        this.isAjaxing = false;
        this.ajaxStatus = nodata;
      });
  }
  handleData(res) {
    const { nomore, end, nodata } = AJAX_STATUS;
    // 没有数据就不做处理
    if (!res.data.list.length) {
      this.ajaxStatus = this[this.keyArr[this.activeIndex]].length ? nomore : nodata;
      return;
    }
    this.ajaxStatus = end;
    const tempArr = [];
    // 获取阅读数接口的key整合
    res.data.list.forEach(item => {
      tempArr.push(`seq_${item.pid}`);
      this.$set(
        this.$followOrgList,
        item.orgId,
        this.$followOrgList.hasOwnProperty(item.orgId) ? this.$followOrgList[item.orgId] : 1
      );
      item.stockCode = formateHkStockcode(item.stockCode, item.market);
    });
    // 优化获取阅读数
    this.handleReadNum(tempArr, res);
  }
  handleReadNum(tempArr, res) {
    getReadNum({
      field: 'clicks',
      key: tempArr.join(','),
    })
      .then(num => {
        // 整合阅读数
        this[this.keyArr[this.activeIndex]] = this[this.keyArr[this.activeIndex]].concat(
          res.data.list.map(item => ({
            ...item,
            readNum: num.result[`seq_${item.pid}`],
          }))
        );
        this.handleCardJump();
        this.$nextTick(() => {
          this.isAjaxing = false;
          const dom = this.$refs.reportBlock as HTMLElement;
          this.clientHeight = dom.clientHeight;
          this.totalHeight = dom.parentElement.clientHeight;
        });
      })
      .catch(() => {
        // 出问题直接赋值
        this.isAjaxing = false;
        this[this.keyArr[this.activeIndex]] = res.data.list;
      });
  }
  handleCardJump() {
    // 处理从卡片的跳转
    if (window.getParam('jumpTab') === 'cover' && !this.isInitCardJump) {
      const pid = window.getParam('pid');
      // 有卡片跳转的页面地址信息 并且没有进行过处理 将状态设置为已经处理
      this.isInitCardJump = true;
      // 模块定位的dom
      setTimeout(() => {
        let dom = this.$refs.reportBlock as HTMLElement;
        if (pid) {
          const index = this.coverList.findIndex(item => `${item.pid}` === pid);
          // 获取研报所在的索引
          if (index > -1) {
            // 将对应索引的dom滚动到指定位置
            dom = this.$refs[`cover${index}`][0].$el;
          }
        }
        // 将模块滚动到指定位置
        window.scrollTo({
          left: 0,
          top: getDomTop(dom) + 10,
          behavior: 'smooth',
        });
      }, 500);
    }
  }
  mounted() {
    if (window.getParam('jumpTab') === 'cover') {
      // 如果有从卡片过来的信息需要将tab切换过去
      this.handleTabClick(1);
    }
    // 获取视窗高度
    this.viewHeight = getClientHeight();
    // 获取关注信息
    this.getData();
  }
}
